export const sleep = (milliseconds: number) => {
  return new Promise<void>((resolve) => setTimeout(() => resolve(), milliseconds));
};

export const waitWithData = <T>(data: T, milliseconds: number) => {
  return new Promise<T>((resolve) => setTimeout(() => resolve(data), milliseconds));
};
